<template>
  <div>
    <!-- 添加标签弹框 -->
    <el-dialog
      title="添加标签"
      :visible.sync="addLabel"
      append-to-body
      width="735px"
      height="470px"
      style="margin-top:4vh;"
      class="add-label-dialog"
      :close-on-click-modal="false"
    >
      <!-- <el-row class="search-label" :gutter="24" >
        <el-col :span="24">
          
        </el-col>
      </el-row> -->
      <div class="search-label">
        <el-input
          placeholder="输入关键词"
          size="small"
          v-model="searchLabelName"
          clearable
          style="width:100%"
          :maxlength="15"
          show-word-limit
          >
        </el-input>
      </div>
      <div class="tags-wrap">
        <div v-for="(list,key) in showTagsList" :key="key">
          <el-row v-if="key">
            <span class="label-title">{{ key }}</span>
          </el-row>
          <el-row :gutter="20" v-if="list">
            <el-col class="label-item"  :span="1.5" v-for="(item,index) in list" :key="index">
                <el-checkbox  v-model="item.checked" @change="handleCheckedChange(item.valid)">{{ item.valname }}</el-checkbox> 
            </el-col>
          </el-row>
        </div>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button size="small " @click="addLabel = false" style="margin-right:20px">取 消</el-button>
        <el-button type="primary" size="small" @click="confirmWeicome()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getTags } from "@/api/mass/mass.js"
export default {
  name: 'addTags',
  data() {
    return {
      addLabel: false,
      showTagsList: {},
      allTagsList: {},
      checkedCities: [],
      searchLabelName: '',  // 添加标签中搜索input框对应的字段
      selectTags: []
    }
  },
  watch: {
    searchLabelName(newVal){
      this.searchTagsHandle(newVal)
    }
  },
  methods: {
    show(currentSelectTags) {
      this.selectTags = currentSelectTags?currentSelectTags:[]
      this.getTags()
    },
    // 搜索
    searchTagsHandle(val) {
      let searchResArr = JSON.parse(JSON.stringify(this.allTagsList))
      if(val != '') {
        for(let key in searchResArr) {
          this.showTagsList[key] = searchResArr[key].filter(v=>{
            return v.valname.indexOf(val)!= -1
          })
        }
      }else {
        this.showTagsList = searchResArr;
      }
    },
    // 确定按钮
    confirmWeicome() {
      let strArr = [];
      let tagsNameList = []
      let obj = JSON.parse(JSON.stringify(this.allTagsList))
      for(let i in obj) {
        for(let index = 0; index< obj[i].length; index++) {
          if(obj[i][index].checked) {
            let strObj = {
              tagId: obj[i][index].valid,
              tagName: obj[i][index].valname
            }
            strArr.push(strObj)
            tagsNameList.push(obj[i][index].valname)
          }
        }
      }
      let sendObj = {
        tagsList: strArr,
        nameList: tagsNameList
      }
      this.searchLabelName = '';
      this.$emit('addTagsConfirm',sendObj)
      this.addLabel = false;
    },
    handleCheckedChange(valid) {
      for(let key in this.allTagsList) {
        for(let i = 0; i< this.allTagsList[key].length; i++) {
          if(this.allTagsList[key][i].valid == valid) {
            this.allTagsList[key][i].checked = !this.allTagsList[key][i].checked;
          }
        }
      }
    },
    // 获取标签
    getTags() {
      let that = this;
      let flag = this.selectTags.length ==0 ? false : true;
      getTags(localStorage.getItem("Authorization")).then(res => {
        if(res.error.code == 200) {
          let obj =  JSON.parse(JSON.stringify(res.data))
          for(let i in obj) {
            for(let index = 0; index< obj[i].length; index++) {
              if(flag) {
                // 若有初始选中标签，则赋值为true
                obj[i][index].checked = false
                this.selectTags.forEach(item => {
                  if(item.tagId === obj[i][index].valid) {
                    obj[i][index].checked = true
                  }
                })
              }else {
                obj[i][index].checked = false
              }
            }
          }
          that.showTagsList = JSON.parse(JSON.stringify(obj));
          that.allTagsList = JSON.parse(JSON.stringify(obj));
          that.addLabel = true;
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
// 添加标签弹框
.add-label-dialog {
  /deep/ .el-dialog__body {
    padding: 30px 0 0;
  }
  .search-label {
    margin-bottom: 15px;
    padding: 0 40px;
  }
  .tags-wrap {
    max-height: 450px;
    padding: 0 40px;
    overflow-y: scroll;
    overflow-x: hidden;
    .label-title {
      font-size: 15px;
      margin: 5px 0px 10px;
      display: inline-block;
      font-weight: bold;
    }
    .label-item {
      margin-bottom: 15px;
    }
  }
  /deep/ .el-dialog__footer{
    text-align: right;
  }
  ::-webkit-scrollbar {
    width: 4px;
    height: 8px;
    background-color: white;
  }
}
</style>